import { Link } from 'react-router-dom';
import Logo from '../images/logo.svg'

const Footer = () => {
  return (
    <footer className="footer">
      <div
        id="rec582886776"
        className="r t-rec t-rec_pt_105 t-rec_pt-res-480_90 t-rec_pb_45 t-rec_pb-res-480_30"
        style={{ paddingTop: '105px', paddingBottom: '45px', backgroundColor: '#d1011b' }}
        data-record-type="33"
        data-animationappear="off"
      >
        <div className="t017">
          <div className="t-container t-align_center">
            <div className="t-col t-col_12">
              <div className="t017__uptitle t-uptitle t-uptitle_md" field="subtitle">
              МЕЖДУНАРОДНАЯ ПРЕМИЯ «ГЛОБАЛЬНЫЙ ПРОРЫВ»
              </div>
              <div className="t017__title t-title t-title_xxs" field="title">
                <div style={{ fontSize: '52px' }} data-customstyle="yes">
                  СТАТЬ ЭКСПЕРТОМ – 2026
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="rec582886778"
        className="r t-rec t-rec_pt_30 t-rec_pt-res-480_15 t-rec_pb_30 t-rec_pb-res-480_15"
        style={{ paddingTop: '30px', paddingBottom: '30px', backgroundColor: '#d1011b' }}
        data-record-type="191"
        data-bg-color="#d1011b"
        data-animationappear="off"
      >
        {/* T142 */}
        <div className="t142">
          <div className="t-container_100">
            <div className="t142__wrapone">
              <div className="t142__wraptwo">
                <a
                  className="t-btn t142__submit t-btn_md"
                  href="/submit"
                  target="_blank"
                  style={{
                    color: '#ffffff',
                    border: '3px solid #e7c8af',
                    backgroundColor: '#e7c8af',
                    borderRadius: '5px',
                    fontFamily: 'Akrobat',
                    textTransform: 'uppercase',
                  }}
                  data-buttonfieldset="button"
                  data-btneffects-first="btneffects-flash"
                  rel="noopener noreferrer"
                >
                  <span className="t142__text">ПОДАТЬ ЗАЯВКУ</span>
                  <div className="t-btn_wrap-effects">
                    <div className="t-btn_effects"></div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="t396">
        <div
          className="t396__artboard red"
          data-artboard-recid="727225419"
          data-artboard-screens="320,480,640,960,1200"
        >
          <div className="t396__carrier" data-artboard-recid="727225419"></div>
          <div className="t396__filter" data-artboard-recid="727225419"></div>

          {/* Элементы */}
          <div
            className="t396__elem tn-elem tn-elem__7272254191580306012860"
            data-elem-id="1580306012860"
          >
            <div className="tn-atom"></div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191475147461250"
            data-elem-id="1475147461250"
          >
            <div className="tn-atom" field="tn_text_1475147461250">
              Телефон: +7 (495) 649-18-28
              <br />
              Адрес: 127473, Москва, ул. Делегатская, д. 8 стр.3
              <br />
              Е-mail: <a href="mailto:info@deloros.com" style={{ color: 'inherit', textDecoration: 'none'}}>info@deloros.com</a>
              <br />
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191580306063084"
            data-elem-id="1580306063084"
          >
            <img
              className="tn-atom__img t-img"
              src="https://static.tildacdn.com/tild6337-6639-4231-b535-353638373036/istockphoto_11997297.png"
              alt=""
              data-original="https://static.tildacdn.com/tild6337-6639-4231-b535-353638373036/istockphoto_11997297.png"
              imgfield="tn_img_1580306063084"
            />
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191475147675390"
            data-elem-id="1475147675390"
          >
            <div className="tn-atom">
              <a href="https://expertgoda.expertnw.com/" style={{ color: 'inherit', textDecoration: 'none'}}>
                О ПРЕМИИ
              </a>
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191475147678114"
            data-elem-id="1475147678114"
          >
            <div className="tn-atom" field="tn_text_1475147678114">
              <a
                href="/submit"
                style={{
                  color: 'rgb(0, 0, 0)',
                  textDecoration: 'none',
                  borderBottom: '0px solid',
                  boxShadow: 'inset 0px -0px 0px 0px',
                }}
              >
                Подать Заявку
              </a>
              <br />
              <a
                href="/winners"
                style={{
                  color: '#000000',
                  textDecoration: 'none',
                  borderBottom: '0px solid',
                  boxShadow: 'inset 0px -0px 0px 0px',
                }}
              >
                Победители
              </a>
              <br />
              <a
                href="/polozhenie"
                style={{
                  color: 'rgb(0, 0, 0)',
                  textDecoration: 'none',
                  borderBottom: '0px solid',
                  boxShadow: 'inset 0px -0px 0px 0px',
                }}
              >
                Положение
                <br />
              </a>
              <a
                href="/creteria"
                style={{ color: 'rgb(0, 0, 0)' , textDecoration: 'none'}}
              >
                Критерии оценки
              </a>
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191475147757614"
            data-elem-id="1475147757614"
          >
            <div className="tn-atom">
              <a  style={{ color: 'inherit' , textDecoration: 'none'}}>
                ИНФОРМАЦИЯ
              </a>
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191475147760185"
            data-elem-id="1475147760185"
          >
            <div className="tn-atom" field="tn_text_1475147760185">
              <a
                href="/news"
                style={{
                  color: 'rgb(29, 28, 33)',
                  textDecoration: 'none',
                  borderBottom: '0px solid',
                  boxShadow: 'inset 0px -0px 0px 0px',
                }}
              >
                Новости
              </a>
              <br />
              <a
                href="/council_of_experts"
                style={{
                  color: 'rgb(0, 0, 0)',
                  textDecoration: 'none',
                  borderBottom: '0px solid',
                  boxShadow: 'inset 0px -0px 0px 0px',
                }}
              >
                Экспертный Совет
              </a>
              <br />
              <a href="/gallery" style={{ color: 'rgb(0, 0, 0)' , textDecoration: 'none'}}>
              Галерея
              </a>
              <br />
              <a
                href="/contacts"
                style={{
                  color: '#1d1c21',
                  textDecoration: 'none',
                  borderBottom: '0px solid',
                  boxShadow: 'inset 0px -0px 0px 0px',
                }}
              >
                Контакты
              </a>
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191475148691530"
            data-elem-id="1475148691530"
          >
            <div className="tn-atom">
              <img
                className="tn-atom__img t-img"
                src="https://static.tildacdn.com/tild3963-3037-4533-a462-346662316263/logo-dark-01.svg"
                alt=""
                data-original="https://static.tildacdn.com/tild3963-3037-4533-a462-346662316263/logo-dark-01.svg"
                imgfield="tn_img_1475148691530"
              />
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191580384276935"
            data-elem-id="1580384276935"
          >
            <div className="tn-atom" field="tn_text_1580384276935">
              КОНТАКТЫ
            </div>
          </div>

          <div
            className="t396__elem tn-elem tn-elem__7272254191645794767734"
            data-elem-id="1645794767734"
          >
            <div className="tn-atom">
              <img
                className="tn-atom__img t-img"
                src="https://static.tildacdn.com/tild3036-3638-4831-b461-356366306637/Logo_expert_nw-monoc.svg"
                alt=""
                data-original="https://static.tildacdn.com/tild3036-3638-4831-b461-356366306637/Logo_expert_nw-monoc.svg"
                imgfield="tn_img_1645794767734"
              />
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
